import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
        credentials: "include",
      });
      if (!res.ok) {
        const data = await res.json();
        setError(data.detail || "Login failed");
        return;
      }
      navigate("/dashboard", { replace: true });
      window.location.reload();
    } catch {
      setError("Connection failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: "#0f1117", fontFamily: "Inter, system-ui, sans-serif",
    }}>
      <div style={{
        width: 380, background: "#1a1d27", borderRadius: 12, padding: "40px 32px",
        border: "1px solid #2a2d3a",
      }}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{
            width: 48, height: 48, borderRadius: 10, background: "#6366f1",
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12,
          }}>M</div>
          <h1 style={{ color: "#e2e8f0", fontSize: 20, fontWeight: 600, margin: 0 }}>
            MEDTL Regulatory Auditor
          </h1>
          <p style={{ color: "#64748b", fontSize: 13, marginTop: 6 }}>
            Sign in to continue
          </p>
        </div>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ display: "block", color: "#94a3b8", fontSize: 13, marginBottom: 6 }}>
              Username
            </label>
            <input
              type="text" value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoFocus required
              style={{
                width: "100%", padding: "10px 12px", borderRadius: 8,
                border: "1px solid #2a2d3a", background: "#0f1117", color: "#e2e8f0",
                fontSize: 14, outline: "none", boxSizing: "border-box",
              }}
            />
          </div>
          <div style={{ marginBottom: 20 }}>
            <label style={{ display: "block", color: "#94a3b8", fontSize: 13, marginBottom: 6 }}>
              Password
            </label>
            <input
              type="password" value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                width: "100%", padding: "10px 12px", borderRadius: 8,
                border: "1px solid #2a2d3a", background: "#0f1117", color: "#e2e8f0",
                fontSize: 14, outline: "none", boxSizing: "border-box",
              }}
            />
          </div>
          {error && (
            <div style={{
              padding: "8px 12px", borderRadius: 8, background: "#2d1b1b",
              border: "1px solid #5c2b2b", color: "#fca5a5", fontSize: 13, marginBottom: 16,
            }}>{error}</div>
          )}
          <button type="submit" disabled={loading} style={{
            width: "100%", padding: "10px 0", borderRadius: 8, border: "none",
            background: "#6366f1", color: "#fff", fontSize: 14, fontWeight: 600,
            cursor: loading ? "wait" : "pointer", opacity: loading ? 0.7 : 1,
          }}>
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
